import React, { useState, useEffect } from 'react';
import './NewsSection.css';
import { newsStorage } from '../../utils/storage';
import { FaCalendarAlt, FaUser, FaArrowRight } from 'react-icons/fa';

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch news from storage
    const loadNews = () => {
      try {
        const storedNews = newsStorage.getAllNews();
        
        // Process stored news to add excerpts
        const processedNews = storedNews.map(item => ({
          ...item,
          excerpt: item.content.length > 100 
            ? item.content.substring(0, 100) + '...' 
            : item.content
        }));
        setNews(processedNews);
        setLoading(false);
      } catch (error) {
        console.error('Error loading news:', error);
        setLoading(false);
      }
    };

    // Simulate loading delay
    setTimeout(loadNews, 500);
  }, []);

  if (loading) {
    return (
      <section className="news-section" id="news">
        <div className="container">
          <div className="section-header">
            <h2>Latest News</h2>
            <p>Stay updated with the latest news and announcements from Alasar Academy</p>
          </div>
          <div className="news-loading">
            <div className="loading-spinner"></div>
            <p>Loading news...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="news-section" id="news">
      <div className="container">
        <div className="section-header">
          <h2>Latest News</h2>
          <p>Stay updated with the latest news and announcements from Alasar Academy</p>
        </div>

        <div className="news-grid">
          {news.map((item) => (
            <article key={item.id} className="news-card">
              <div className="news-image">
                <img src={item.image} alt={item.title} />
                <div className="news-category">{item.category}</div>
              </div>
              
              <div className="news-content">
                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>
                
                <div className="news-meta">
                  <span className="meta-item">
                    <FaCalendarAlt />
                    {new Date(item.date).toLocaleDateString()}
                  </span>
                  <span className="meta-item">
                    <FaUser />
                    {item.author}
                  </span>
                </div>
                
                <button className="read-more">
                  Read More
                  <FaArrowRight />
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="news-footer">
          <button className="btn btn-outline">
            View All News
          </button>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
